import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { userRolesHaveRequiredRole } from "./rolePermissions";
import { localDevAuthBypass } from "../services/auth/localDevAuthBypass";
import { RECRUITMENT_MANAGE_WORKERS_ROLE } from "../constants/authRoles";

// Custom hook that returns the current user's role.
export function useUserRole(): string | undefined {
    return useSelector((state: RootState) => state.auth.role);
}

// React hook that checks if the current user has one of the required roles.
export function useUserHasRole(requiredRole?: string | string[]): boolean {
    const auth = useSelector((state: RootState) => state.auth);
    return userRolesHaveRequiredRole(
        localDevAuthBypass() ? [RECRUITMENT_MANAGE_WORKERS_ROLE] : [auth.role, ...(auth.user?.roles ?? [])],
        requiredRole,
    );
}

export const userHasRole = (userRole: string | undefined, requiredRole: string | string[]): boolean =>
    userRolesHaveRequiredRole([userRole], requiredRole);
